import React, { useRef } from 'react';
import { FormHelperText, FormLabel, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Search } from '@mui/icons-material';
import { ADDRESS_SEARCH_MODAL_ID } from '../AddressSearchModal';

export type AddressQuickSearchInputTypes = {
  label?: React.ReactNode;
  onFocus: () => void;
  errorText?: string;
  placeholder?: string;
  isModalOpen: boolean;
};

export const AddressQuickSearchInput: React.FC<AddressQuickSearchInputTypes> = ({ label, onFocus, errorText, placeholder, isModalOpen }) => {
  const ref = useRef<HTMLButtonElement>(null);
  const { classes, cx } = useQuickSearchInputStyles();

  const handleActivate = () => {
    ref.current?.blur();

    onFocus();
  };
  const error = Boolean(errorText);

  return (
    <div>
      <div>
        <FormLabel error={error}>{label}</FormLabel>
      </div>
      <button
        ref={ref}
        tabIndex={0}
        onFocus={handleActivate}
        onClick={handleActivate}
        className={cx(classes.button, error && classes.buttonError)}
        type="button"
        aria-haspopup="dialog"
        aria-expanded={isModalOpen}
        aria-controls={ADDRESS_SEARCH_MODAL_ID}
      >
        <div className={classes.adornment}>
          <Search />
        </div>
        <Typography className={classes.buttonText} component="span">
          {placeholder ?? 'Quickly search for address'}
        </Typography>
      </button>
      {errorText && (
        <FormHelperText error>
          {errorText}
        </FormHelperText>
      )}
    </div>
  );
};

const useQuickSearchInputStyles = makeStyles({ name: 'QuickSearchInput' })(theme => ({
  button: {
    // unset: 'all',
    fontFamily: 'inherit',
    cursor: 'text',
    width: '100%',
    display: 'flex',
    border: '1px solid rgba(0, 0, 0, 0.23)',
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1),
    paddingLeft: '14px',
    height: '48px',
    background: theme.palette.background.paper,
    alignItems: 'center',
    transition: theme.transitions.create([ 'border-color' ]),

    '&:focus': {
      outline: 'none',
      borderColor: theme.palette.secondary.main
    },
    '&:hover': {
      borderColor: theme.palette.text.primary
    }
  },
  buttonError: {
    borderColor: theme.palette.error.main,
    '&:hover': {
      borderColor: theme.palette.error.main
    },

    '& *': {
      color: `${theme.palette.error.main} !important`,
    }
  },
  adornment: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    marginRight: theme.spacing(1),
    color: theme.palette.text.primary
  },
  buttonText: {
    color: theme.palette.text.disabled,
    display: 'block',
    fontSize: '16px',
    fontStyle: 'italic',
  },
}));
